import { doc, runTransaction } from 'firebase/firestore';
import { db } from '../firebaseConfig';

export async function getNextOrderNumber(activeFarmId) {
  if (!activeFarmId) {
    throw new Error('No active farm selected.');
  }
  const counterRef = doc(db, 'farms', activeFarmId, 'counters', 'orders');
  try {
    const newOrderNumber = await runTransaction(db, async (transaction) => {
      const counterDoc = await transaction.get(counterRef);
      if (!counterDoc.exists()) {
        transaction.set(counterRef, { orderCount: 1 });
        return 1;
      }
      const currentCount = Number(counterDoc.data().orderCount) || 0;
      const nextCount = currentCount + 1;
      transaction.update(counterRef, { orderCount: nextCount });
      return nextCount;
    });
    return newOrderNumber;
  } catch (e) {
    console.error("Transaction failed: ", e);
    throw e;
  }
}
